"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
let TagGroup = class TagGroup extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
TagGroup.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-wrap: wrap;
      gap: var(--space-1);
    }
  `;
TagGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-tag-group')
], TagGroup);
exports.TagGroup = TagGroup;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFnLWdyb3VwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGFnLWdyb3VwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBaUQ7QUFHMUMsSUFBTSxRQUFRLEdBQWQsTUFBTSxRQUFTLFNBQVEsZ0JBQVU7SUFTdEMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7O0tBRVYsQ0FBQTtJQUNILENBQUM7O0FBWk0sZUFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7R0FNbEIsQ0FBQTtBQVBVLFFBQVE7SUFEcEIsSUFBQSw2QkFBYSxFQUFDLGNBQWMsQ0FBQztHQUNqQixRQUFRLENBY3BCO0FBZFksNEJBQVEifQ==